<template>
  <div class="loading-mask">
    <i class="el-icon-loading icon"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less">
.loading-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 3500;
  .icon {
    font-size: 24px;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50% -50%);
  }
}
</style>
